export default "__VITE_ASSET__aba25423__"